import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  CButton, CCard, CCardBody, CCardGroup, CCol, CContainer, CForm, CFormInput,
  CInputGroup, CInputGroupText, CRow
} from '@coreui/react';
import { withFirebase } from '../../firebase';

const INITIAL_STATE = {
  email: '',
  error: null,
};

class PasswordForget extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    const { email } = this.state;
    event.preventDefault();

    this.props.firebase
      .doPasswordReset(email)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
        console.log("Password reset email sent successfully");
      })
      .catch(error => {
        this.setState({ error });
        console.error("Error sending password reset email: ", error);
      });
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, error } = this.state;
    const isInvalid = email === '';

    return (
      <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
        <CContainer>
          <CRow className="justify-content-center">
            <CCol md="8">
              <CCardGroup>
                <CCard className="p-4">
                  <CCardBody>
                    <CForm onSubmit={this.onSubmit}>
                      <h1>Reset Password</h1>
                      <p className="mb-2">Enter your email to reset your password</p>
                      <CInputGroup className="mb-3">
                        <CInputGroupText>
                          <i className="icon-envelope"></i>
                        </CInputGroupText>
                        <CFormInput
                          name="email"
                          value={email}
                          onChange={this.onChange}
                          type="email"
                          placeholder="Email Address"
                          autoComplete="email"
                        />
                      </CInputGroup>
                      {error && <p className="text-danger">{error.message}</p>}
                      <CRow>
                        <CCol xs="6">
                          <CButton color="primary" className="px-4" disabled={isInvalid} type="submit">
                            Reset My Password
                          </CButton>
                        </CCol>
                        <CCol xs="6" className="text-right">
                          <Link to="/login">
                            <CButton color="link" className="px-0">Sign In</CButton>
                          </Link>
                        </CCol>
                      </CRow>
                    </CForm>
                  </CCardBody>
                </CCard>
                <CCard className="text-white bg-primary py-5 d-md-down-none" style={{ width: '44%' }}>
                  <CCardBody className="text-center">
                    <div>
                      <h2>Sign Up</h2>
                      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                      <Link to="/register">
                        <CButton color="primary" className="mt-3" active tabIndex={-1}>Register Now!</CButton>
                      </Link>
                    </div>
                  </CCardBody>
                </CCard>
              </CCardGroup>
            </CCol>
          </CRow>
        </CContainer>
      </div>
    );
  }
}

export default withFirebase(PasswordForget);


